export default class OrderCancel {
  cancelDetails?: string;
  cancelDate?: Date;
}
